function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
export const roundedFull = process.env.NODE_ENV === "production" ? {
  name: "j033lg",
  styles: "border-radius:9999px"
} : {
  name: "kgbq1j-roundedFull",
  styles: "border-radius:9999px;label:roundedFull;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const rounded3xl = process.env.NODE_ENV === "production" ? {
  name: "1c1mkf2",
  styles: "border-radius:1.5rem"
} : {
  name: "26nyjt-rounded3xl",
  styles: "border-radius:1.5rem;label:rounded3xl;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const rounded2xl = process.env.NODE_ENV === "production" ? {
  name: "lb1jp4",
  styles: "border-radius:1rem"
} : {
  name: "jzx30b-rounded2xl",
  styles: "border-radius:1rem;label:rounded2xl;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const roundedXl = process.env.NODE_ENV === "production" ? {
  name: "13cfje2",
  styles: "border-radius:0.75rem"
} : {
  name: "mqbo1a-roundedXl",
  styles: "border-radius:0.75rem;label:roundedXl;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const roundedLg = process.env.NODE_ENV === "production" ? {
  name: "1cgt0cu",
  styles: "border-radius:0.5rem"
} : {
  name: "ya2orp-roundedLg",
  styles: "border-radius:0.5rem;label:roundedLg;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const roundedMd = process.env.NODE_ENV === "production" ? {
  name: "zowvxu",
  styles: "border-radius:0.25rem"
} : {
  name: "4jkatt-roundedMd",
  styles: "border-radius:0.25rem;label:roundedMd;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const roundedSm = process.env.NODE_ENV === "production" ? {
  name: "28e56t",
  styles: "border-radius:0.125rem"
} : {
  name: "jezql0-roundedSm",
  styles: "border-radius:0.125rem;label:roundedSm;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};